var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "39d7e8f4-da8d-49bc-8be9-58bb866b5f31"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "18ad25df-31d4-424e-9a4c-6ef8fec6a650"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94 0 0 0.94 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -302 -29.5)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-275.25, -106.1)",
    d: "M 428.5 106.1 C 428.5 146 402 179.6 365.7 190.5 C 357.7 192.9 349.2 194.2 340.4 194.2 L 151.4 194.2 C 135.20000000000002 194.2 122 181.1 122 164.79999999999998 L 337.6 164.79999999999998 C 370.3 164.79999999999998 396.70000000000005 138.29999999999998 396.70000000000005 105.69999999999999 C 396.70000000000005 76.39999999999999 375.40000000000003 52.09999999999999 347.40000000000003 47.39999999999999 L 153.1 47.39999999999999 C 138.7 50.39999999999999 134.5 59.599999999999994 134.5 59.599999999999994 L 134.5 47.4 L 134.1 47.4 C 134.1 39.3 137.4 32 142.7 26.599999999999998 C 148 21.299999999999997 155.39999999999998 18 163.5 18 L 340.4 18 C 349.2 18 357.7 19.3 365.7 21.7 C 402 32.5 428.5 66.2 428.5 106.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -372.65 -54)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-204.6, -81.6)",
    d: "M 365.7 96.3 L 72.9 96.3 C 56.7 96.3 43.50000000000001 83.2 43.50000000000001 66.9 L 336.3 66.9 C 352.6 66.9 365.7 80.1 365.7 96.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -352.55 -5)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-224.7, -130.6)",
    d: "M 365.7 115.9 C 365.7 124 362.4 131.3 357.09999999999997 136.70000000000002 C 351.79999999999995 142.00000000000003 344.4 145.3 336.29999999999995 145.3 L 113.1 145.3 C 96.89999999999999 145.3 83.69999999999999 132.20000000000002 83.69999999999999 115.9 L 365.7 115.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -82.05 5.6)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-495.2, -141.2)",
    d: "M 464.9 189.3 C 455.9 184.60000000000002 448.9 178 443.9 169.70000000000002 C 438.79999999999995 161.3 436.29999999999995 151.8 436.29999999999995 141.20000000000002 C 436.29999999999995 130.60000000000002 438.79999999999995 121.10000000000002 443.9 112.70000000000002 C 449 104.30000000000001 456 97.80000000000001 464.9 93.10000000000002 C 473.9 88.40000000000002 484 86.00000000000003 495.29999999999995 86.00000000000003 C 506.59999999999997 86.00000000000003 516.6999999999999 88.40000000000003 525.5999999999999 93.10000000000002 C 534.4999999999999 97.80000000000003 541.4999999999999 104.40000000000002 546.4999999999999 112.70000000000002 C 551.5999999999999 121.10000000000002 554.0999999999999 130.60000000000002 554.0999999999999 141.20000000000002 C 554.0999999999999 151.8 551.5999999999999 161.3 546.4999999999999 169.70000000000002 C 541.3999999999999 178.10000000000002 534.4999999999999 184.60000000000002 525.5999999999999 189.3 C 516.6999999999999 194 506.5999999999999 196.4 495.2999999999999 196.4 C 484 196.3 473.9 194 464.9 189.3 z M 515 162.7 C 520.1 157.29999999999998 522.7 150.1 522.7 141.1 C 522.7 132.1 520.1 124.8 515 119.5 C 509.9 114.1 503.3 111.4 495.4 111.4 C 487.4 111.4 480.79999999999995 114.10000000000001 475.7 119.5 C 470.5 124.9 467.9 132.1 467.9 141.1 C 467.9 150.1 470.5 157.4 475.7 162.7 C 480.9 168.1 487.5 170.79999999999998 495.4 170.79999999999998 C 503.3 170.8 509.9 168.1 515 162.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.95 5.45)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-617.2, -141.05)",
    d: "M 678.4 87.4 L 633.1 194.7 L 601 194.7 L 556 87.4 L 588.1 87.4 L 617.8000000000001 160.4 L 648.5000000000001 87.4 L 678.4 87.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 159.55 5.7)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-736.8, -141.3)",
    d: "M 792.7 149.9 L 711.5 149.9 C 713 156.6 716.4 161.8 721.9 165.70000000000002 C 727.4 169.60000000000002 734.1 171.50000000000003 742.1999999999999 171.50000000000003 C 747.8 171.50000000000003 752.6999999999999 170.70000000000002 757.0999999999999 169.00000000000003 C 761.3999999999999 167.30000000000004 765.3999999999999 164.70000000000002 769.1999999999999 161.10000000000002 L 785.8 179.10000000000002 C 775.6999999999999 190.70000000000002 760.9 196.50000000000003 741.5 196.50000000000003 C 729.4 196.50000000000003 718.7 194.10000000000002 709.4 189.40000000000003 C 700.1 184.70000000000005 692.9 178.10000000000002 687.9 169.80000000000004 C 682.8 161.40000000000003 680.3 151.90000000000003 680.3 141.30000000000004 C 680.3 130.80000000000004 682.8 121.30000000000004 687.8 112.90000000000003 C 692.8 104.50000000000003 699.5999999999999 97.90000000000003 708.3 93.20000000000003 C 717 88.50000000000003 726.6999999999999 86.10000000000004 737.5 86.10000000000004 C 748 86.10000000000004 757.5 88.40000000000003 766 92.90000000000003 C 774.5 97.40000000000003 781.2 103.90000000000003 786 112.30000000000004 C 790.9 120.70000000000005 793.3 130.50000000000003 793.3 141.70000000000005 C 793.3 141.9 793.1 144.7 792.7 149.9 z M 719.9 115.4 C 715.1 119.4 712.1999999999999 124.80000000000001 711.1 131.8 L 764 131.8 C 762.9 125.00000000000001 760 119.60000000000001 755.2 115.50000000000001 C 750.4000000000001 111.40000000000002 744.6 109.40000000000002 737.6 109.40000000000002 C 730.6 109.4 724.7 111.4 719.9 115.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 264.9 -5.55)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-842.15, -130.05)",
    d: "M 883.2 189.6 C 880.1 191.9 876.4000000000001 193.6 871.9000000000001 194.7 C 867.4000000000001 195.79999999999998 862.8000000000001 196.39999999999998 857.8000000000001 196.39999999999998 C 845.0000000000001 196.39999999999998 835.2 193.09999999999997 828.2 186.59999999999997 C 821.2 180.09999999999997 817.7 170.49999999999997 817.7 157.89999999999998 L 817.7 113.79999999999998 L 801.1 113.79999999999998 L 801.1 89.8 L 817.7 89.8 L 817.7 63.7 L 848.8000000000001 63.7 L 848.8000000000001 89.80000000000001 L 875.5000000000001 89.80000000000001 L 875.5000000000001 113.70000000000002 L 848.8000000000001 113.70000000000002 L 848.8000000000001 157.40000000000003 C 848.8000000000001 161.90000000000003 850.0000000000001 165.40000000000003 852.3000000000001 167.90000000000003 C 854.6 170.40000000000003 857.9000000000001 171.60000000000002 862.2 171.60000000000002 C 867.1 171.60000000000002 871.3000000000001 170.3 874.8000000000001 167.60000000000002 L 883.2 189.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 367.6 5.4)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-944.85, -141)",
    d: "M 982.4 97.7 C 991.3 105.60000000000001 995.8 117.5 995.8 133.5 L 995.8 194.7 L 966.6999999999999 194.7 L 966.6999999999999 181.29999999999998 C 960.8 191.29999999999998 949.9 196.29999999999998 933.9999999999999 196.29999999999998 C 925.7999999999998 196.29999999999998 918.5999999999999 194.89999999999998 912.5999999999999 192.1 C 906.4999999999999 189.29999999999998 901.8999999999999 185.5 898.6999999999999 180.5 C 895.4999999999999 175.6 893.9 170 893.9 163.7 C 893.9 153.7 897.6999999999999 145.89999999999998 905.1999999999999 140.2 C 912.6999999999999 134.5 924.3 131.6 939.9999999999999 131.6 L 964.6999999999999 131.6 C 964.6999999999999 124.8 962.5999999999999 119.6 958.4999999999999 115.89999999999999 C 954.3999999999999 112.19999999999999 948.1999999999999 110.39999999999999 939.9999999999999 110.39999999999999 C 934.2999999999998 110.39999999999999 928.6999999999999 111.3 923.0999999999999 113.1 C 917.5999999999999 114.89999999999999 912.8999999999999 117.3 908.9999999999999 120.39999999999999 L 897.7999999999998 98.69999999999999 C 903.5999999999998 94.6 910.6999999999998 91.39999999999999 918.7999999999998 89.1 C 926.9999999999999 86.8 935.3999999999999 85.69999999999999 943.9999999999999 85.69999999999999 C 960.7 85.9 973.5 89.8 982.4 97.7 z M 955.8 171.7 C 959.9 169.2 962.8 165.6 964.5999999999999 160.79999999999998 L 964.5999999999999 149.79999999999998 L 943.3 149.79999999999998 C 930.5 149.79999999999998 924.1999999999999 153.99999999999997 924.1999999999999 162.39999999999998 C 924.1999999999999 166.39999999999998 925.8 169.49999999999997 928.9 171.89999999999998 C 932 174.2 936.3 175.39999999999998 941.8 175.39999999999998 C 947 175.4 951.7 174.2 955.8 171.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 462.15 -19.4)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1039.4, -116.2)",
    d: "M 1025.4 67.5 C 1021.8000000000001 64.2 1020.0000000000001 60.1 1020.0000000000001 55.1 C 1020.0000000000001 50.2 1021.8000000000001 46.1 1025.4 42.7 C 1029 39.400000000000006 1033.6000000000001 37.7 1039.4 37.7 C 1045.1000000000001 37.7 1049.8000000000002 39.300000000000004 1053.4 42.5 C 1057 45.7 1058.8000000000002 49.7 1058.8000000000002 54.5 C 1058.8000000000002 59.7 1057.0000000000002 64 1053.4 67.4 C 1049.8000000000002 70.80000000000001 1045.2 72.5 1039.4 72.5 C 1033.7 72.5 1029 70.8 1025.4 67.5 z M 1023.9 87.4 L 1055 87.4 L 1055 194.7 L 1023.9 194.7 L 1023.9 87.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 522.2 -14.8)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1099.45, -120.8)",
    d: "M 1083.9 46.8 L 1115 46.8 L 1115 194.8 L 1083.9 194.8 L 1083.9 46.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 422.45 96.8)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-999.7, -232.4)",
    d: "M 990.7 249.8 C 987.4000000000001 248.10000000000002 984.8000000000001 245.70000000000002 983 242.70000000000002 C 981.2 239.70000000000002 980.2 236.20000000000002 980.2 232.4 C 980.2 228.6 981.1 225.1 983 222.1 C 984.8 219.1 987.4 216.7 990.7 215 C 994 213.3 997.7 212.4 1001.8000000000001 212.4 C 1005.9000000000001 212.4 1009.4000000000001 213.3 1012.5000000000001 215 C 1015.5000000000001 216.7 1017.8000000000001 219.1 1019.2000000000002 222.3 L 1010.5000000000001 227 C 1008.5000000000001 223.4 1005.6000000000001 221.7 1001.8000000000001 221.7 C 998.9000000000001 221.7 996.4000000000001 222.7 994.5000000000001 224.6 C 992.6000000000001 226.5 991.6000000000001 229.1 991.6000000000001 232.4 C 991.6000000000001 235.70000000000002 992.6000000000001 238.3 994.5000000000001 240.20000000000002 C 996.4000000000001 242.10000000000002 998.8000000000001 243.10000000000002 1001.8000000000001 243.10000000000002 C 1005.6 243.10000000000002 1008.5000000000001 241.3 1010.5000000000001 237.8 L 1019.2000000000002 242.60000000000002 C 1017.8000000000002 245.70000000000002 1015.6000000000001 248.10000000000002 1012.5000000000001 249.8 C 1009.5000000000001 251.5 1005.9000000000001 252.4 1001.8000000000001 252.4 C 997.7 252.3 994 251.5 990.7 249.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 460.45 96.6)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1037.7, -232.2)",
    d: "M 1041.8 213.9 C 1044.1 212.9 1046.7 212.5 1049.7 212.5 L 1049.7 222.9 C 1048.5 222.8 1047.6000000000001 222.8 1047.2 222.8 C 1044 222.8 1041.5 223.70000000000002 1039.6000000000001 225.5 C 1037.8000000000002 227.3 1036.9 230 1036.9 233.6 L 1036.9 251.9 L 1025.7 251.9 L 1025.7 213 L 1036.4 213 L 1036.4 218.1 C 1037.7 216.3 1039.5 214.8 1041.8 213.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 512 96.55)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,244,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1089.25, -232.15)",
    d: "M 1117.6 216.7 C 1120.5 219.6 1121.8999999999999 223.79999999999998 1121.8999999999999 229.6 L 1121.8999999999999 251.79999999999998 L 1110.6999999999998 251.79999999999998 L 1110.6999999999998 231.39999999999998 C 1110.6999999999998 228.29999999999998 1110.1 225.99999999999997 1108.7999999999997 224.49999999999997 C 1107.4999999999998 222.99999999999997 1105.6999999999998 222.19999999999996 1103.3999999999996 222.19999999999996 C 1100.7999999999997 222.19999999999996 1098.6999999999996 223.09999999999997 1097.0999999999997 224.79999999999995 C 1095.5999999999997 226.49999999999994 1094.7999999999997 228.99999999999994 1094.7999999999997 232.39999999999995 L 1094.7999999999997 251.79999999999995 L 1083.5999999999997 251.79999999999995 L 1083.5999999999997 231.39999999999995 C 1083.5999999999997 225.29999999999995 1081.1999999999996 222.29999999999995 1076.2999999999997 222.29999999999995 C 1073.6999999999998 222.29999999999995 1071.5999999999997 223.19999999999996 1070.0999999999997 224.89999999999995 C 1068.5999999999997 226.59999999999994 1067.7999999999997 229.09999999999994 1067.7999999999997 232.49999999999994 L 1067.7999999999997 251.89999999999995 L 1056.5999999999997 251.89999999999995 L 1056.5999999999997 213 L 1067.2999999999997 213 L 1067.2999999999997 217.5 C 1068.6999999999998 215.9 1070.4999999999998 214.6 1072.5999999999997 213.8 C 1074.6999999999996 212.9 1076.9999999999998 212.5 1079.4999999999998 212.5 C 1082.1999999999998 212.5 1084.6999999999998 213 1086.8999999999999 214.1 C 1089.1 215.2 1090.8999999999999 216.79999999999998 1092.1999999999998 218.79999999999998 C 1093.7999999999997 216.79999999999998 1095.7999999999997 215.2 1098.1999999999998 214.1 C 1100.6 213 1103.2999999999997 212.4 1106.1999999999998 212.4 C 1110.9 212.4 1114.7 213.9 1117.6 216.7 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogoWhite);
export default __webpack_public_path__ + "static/media/siteLogoWhite.f4320cc2ff5bba879e6cd9300954f956.svg";
export { ForwardRef as ReactComponent };